import MICROSLOTSLOTActions from './MICROSLOTSLOTActions'

export default class MICROSLOTEGAMEActions extends MICROSLOTSLOTActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'EGAME',
      gameCode: 'MICRO-EGAME-001',
      platform: 'MICROSLOT',
    }

    this.gameName = 'Monkey King'
  }
}
